// Helper für das Auf-/Zuklappen der Teilbeträge einer Leistung in Tabellen

// Eindeutige ID für eine Sub-Zeile eines bestimmten Teilbetrags
export function makeSubRowId(mainLeistungId, idx) {
  return `${mainLeistungId}-teilbetrag-${idx}`;
}

export function hasExpandableSubRows(mainLeistung) {
  return (mainLeistung?.teilbetraege?.length ?? 0) > 1;
}

// Baut die Sub-Zeilen aus Main-Leistung und einem Teilbetrag
export function buildSubRow(mainLeistung, teilbetrag, idx) {
  return {
    ...mainLeistung,
    id: makeSubRowId(mainLeistung.id, idx),
    betrag: teilbetrag.betrag,
    satzart: teilbetrag.satzart,
    teilbetraege: [teilbetrag],
    isSubRow: true,
    mainLeistungId: mainLeistung.id,
    // Diese Felder gelten nur pro Leistung (Main-Row) und werden auf Sub-Rows geleert
    rechnungsnummer: null,
    freigaben: null,
    freigabebetrag: null,
    freigabedatum: null,
    freigegebenVon: null,
    tvzBuchen: null,
  };
}

// Baut alle Sub-Zeilen einer Main-Leistung als Array
export function buildSubRowsFor(mainLeistung) {
  return (mainLeistung.teilbetraege ?? []).map((teilbetrag, idx) =>
    buildSubRow(mainLeistung, teilbetrag, idx)
  );
}

// Toggle-Helper für ein expandedLeistungIds-Set
export function toggleExpandedId(expandedSet, leistungId) {
  const next = new Set(expandedSet);
  if (next.has(leistungId)) {
    next.delete(leistungId);
  } else {
    next.add(leistungId);
  }
  return next;
}

export function buildDisplayedLeistungen(mainLeistungen, expandedIds) {
  const result = [];
  mainLeistungen.forEach(mainLeistung => {
    result.push(mainLeistung);
    if (hasExpandableSubRows(mainLeistung) && expandedIds.has(mainLeistung.id)) {
      buildSubRowsFor(mainLeistung).forEach(subRow => result.push(subRow));
    }
  });
  return result;
}
